<ng-container *transloco="let t">
  <ng-container *ngIf="isAdmin; else userTemplate">
    <div [class.admin-template]="isAdmin">
      @if (showEmptyState || competitors.length > 0) {
        @if (showHeader) {
          <div>
            <app-races-header [race]="race" [showExportButton]="false" [showName]="true" [languages]="languages"
                              [defaultLanguage]="event?.defaultLanguage" [cssClass]="'small'" [isAdmin]="isAdmin">
            </app-races-header>
          </div>
        }

        <div class="d-flex justify-content-between">
          <div class="d-flex">
            @if (filteringEnabled) {
              <div class="d-flex flex-column flex-xxl-row">
                <div class="pe-2">
                  <app-search-rounded [name]="name" [placeholder]="t('explore.search')"
                                      (searchEmitter)="handleSearchInput($event)"></app-search-rounded>
                </div>
                <div class="w-180 d-flex pe-2">
                  <app-select [hasDefault]="true" [items]="competitorStatuses" [ngModel]="selectedStatus"
                              (ngModelChange)="handleStatusSelection($event)" [defaultValue]="undefined"
                              [defaultLabel]="t('app.common.all')" labelKeyPrefix="competitor.table.status."
                              [fullWidthDropdown]="true"/>
                </div>
                @if (isApplicationFormFieldVisible('sex')) {
                  <div class="w-180 d-flex">
                    <app-select [hasDefault]="true" [items]="genders" [ngModel]="gender"
                                [defaultValue]="undefined" [defaultLabel]="t('app.common.all')"
                                labelKeyPrefix="app.common.gender." (ngModelChange)="handleGenderSelection($event)"
                                [fullWidthDropdown]="true"/>
                  </div>
                }
                @if (isApplicationFormFieldVisible('category') && categories.length > 0) {
                  <div class="w-180 d-flex">
                    <app-select [hasDefault]="true" [items]="categories" [ngModel]="category"
                                [defaultValue]="undefined"
                                [defaultLabel]="t('app.common.all')" [valueKey]="'id'" [labelKey]="'name'"
                                (ngModelChange)="handleCategorySelection($event)"
                                [fullWidthDropdown]="true"/>
                  </div>
                }
              </div>
            }
            <ng-content select="[slot='competitorTableAdminLeadingWidgets']"></ng-content>
          </div>

          <ng-content select="[slot='competitorTableAdminTrailingWidgets']"></ng-content>
        </div>

        <app-loader [isLoading]="isLoading"></app-loader>
        <div class="table-responsive competitor-table" [ngClass]="{'pt-16 mb-16': showHeader}">
          @if (competitors.length > 0) {
            <div>
              <div [ngClass]="{'scrollable-table': !showLoadMoreButton}"
                   (scroll)="!(gender || name || category) ? onScroll($event): undefined">
                @for (competitor of competitors;track competitor) {
                  <ng-container>
                    <div class="align-items-center d-flex d-xxl-none">
                      <div class="pe-4 fw-bolder fs-5">
                          <span [class.opacity-25]="!!competitor.startNumber">{{ competitor.startNumber ?? '00' }}</span>
                      </div>
                      <div class="d-flex flex-column py-3 item-border-bottom flex-grow-1">
                        <div class="fw-bold line-height-12">
                          {{
                            ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                              ?? "") | titlecase)
                          }}
                        </div>
                        <div class="d-inline-flex">-</div>
                        <div class="d-inline-flex">{{ t("app.common.gender." + competitor.sex) }}</div>
                        <ng-container>
                          <span>{{ ', ' }}{{ competitor.categoryLabel }}</span>
                        </ng-container>

                        <div class="d-flex flex-row">
                        <span class="badge rounded-pill ms-2">
                          {{ t("competitor.table.status." + competitor.status) }}
                        </span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                }

                <div class="d-flex">
                  <div class="flex-grow-1" style="overflow-x: hidden ">
                    <div class="d-none d-xxl-flex">
                      <app-sortable-table [cssClass]="tableClasses"
                                          [items]="!currentCompetitor ? competitors: undefined">
                        <thead class="table-header">
                        <tr>
                          @for (field of competitorCols;track field) {
                            <th scope="col" [sortBy]="[field]">
                              <div class="d-flex align-items-end justify-content-start">
                                <div class="col-name-holder">
                                  {{ t('competitor.table.' + field) }}
                                </div>
                                <div class="icon-holder">
                                </div>
                              </div>
                            </th>
                          }
                          @if(displayRaceName) {
                          <th scope="col">
                         <div class="d-flex align-items-end justify-content-start">
                           <div class="col-name-holder">
                             {{t("app.common.race")}}
                           </div>
                           <div class="icon-holder">
                           </div>
                         </div>
                       </th>
}

                          @for (customColumn of customCols;track customColumn) {
                            <th scope="col">
                              <div class="d-flex align-items-end justify-content-start">
                                <div class="col-name-holder">
                                  <app-language-output [hrLabel]="customColumn.name" [enLabel]="customColumn.nameEng"
                                                       [itLabel]="customColumn.nameIta" [siLabel]="customColumn.nameSlo"
                                                       [defaultLanguage]="event?.defaultLanguage"
                                                       [languages]="languages"/>
                                </div>
                                <div class="icon-holder">
                                </div>
                              </div>
                            </th>
                          }
                          <th class="more-th text-end" [ngClass]="{'width-50': !currentCompetitor?.id,
                          'width-100': currentCompetitor?.id }">
                            <app-multiselect-dropdown [options]="getOptions()" [maxItemsCount]="maxColsNum"
                                                      [disabled]="!!currentCompetitor" [ngModel]="selectedFields"
                                                      (ngModelChange)="onSelectedFieldsChange($event)"
                                                      buttonIconClass="bi bi-list"
                                                      [isTableHeading]="true" [isButton]="true"
                                                      [iconClass]="'menu-icon--small'"/>
                          </th>
                        </tr>
                        </thead>
                        <tr app-table-header-separator></tr>
                        <tbody #tbody>
                          @for (competitor of competitors;track competitor.id;let idx = $index) {
                            <tr class="clickable" (dblclick)="editCompetitor(competitor)">
                              @for (column of competitorCols;track column) {
                                <td class="center-align">
                            <span class="text-truncate fs-15">
                              @switch (column) {
                                @case ('startNumber') {
                                  @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                                  === competitor?.id) {
                                    <div class="d-flex">
                                      <ng-container>
                                        <input class="table-inp" placeholder="00"
                                               [(ngModel)]="currentCompetitor!.startNumber">
                                      </ng-container>
                                    </div>
                                  } @else {
                                    @if (competitor.startNumber) {
                                      {{ competitor.startNumber }}
                                    } @else {
                                      <span class="opacity-25">{{ '00' }}</span>
                                    }
                                  }
                                }
                              @case ('startBlock') {
                                  @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                                  === competitor?.id) {
                              <div class="d-flex">
                                <ng-container>
                                  <input class="table-inp" placeholder="00"
                                         [(ngModel)]="currentCompetitor!.startBlock">
                                </ng-container>
                              </div>
                                  } @else {
                              @if (competitor.startBlock) {
                              {{ competitor.startBlock }}
                              } @else {
                                      <span class="opacity-25">{{ '00' }}</span>
                                    }
                                  }
                                }
                                @case ('presentAtStart') {
                                  @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                                  === competitor?.id) {
                                    <div class="form-check form-switch d-flex align-items-center">
                                      <input ngDefaultControl class="form-check-input" type="checkbox"
                                             [(ngModel)]="currentCompetitor!.presentAtStart">
                                    </div>
                                  } @else {
                                    {{ competitor.presentAtStart ? t("app.common.yes") : t("app.common.no") }}
                                  }
                                }
                                @case ('status') {
                                  <div class="status-badge publishing" style="max-width: 100px">
                                    <span class="text-uppercase">
                                      {{ t("competitor.table.status." + competitor.status) }}
                                    </span>
                                  </div>
                                }
                                @case ('sex') {
                                  {{ t("app.common.gender." + competitor.sex) }}
                                }
                                @case ('created') {
                                  {{ competitor.created ?? '' | localizedDate:'shortDate' }}
                                }
                                @case ('modified') {
                                  {{ competitor.modified ?? '' | localizedDate:'short' }}
                                }
                                @case ('meal') {
                                  {{ t("app.common.meal." + competitor.meal) }}
                                }
                                @case ('transport') {
                                  {{ t("app.common.transport." + competitor.transport) }}
                                }
                                @case ('tshirt') {
                                  {{ t("app.common.tshirt." + competitor.tshirt) }}
                                }
                                @case ('fullName') {
                                  {{
                                    ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                                      ?? "") | titlecase)
                                  }}
                                }
                                @default {
                                  {{ competitor[column] ?? "-" }}
                                }
                              }
                            </span>
                                </td>
                              }
                          @if (displayRaceName) {
                          <td class="center-align">
                             <span class="text-wrap">
                                <ng-container *ngIf="(event?.racesList | filterByField: 'id': competitor.raceId : true)[0] as race">
                                       <app-language-output [hrLabel]="race.name" [enLabel]="race.nameEng"
                                                            [itLabel]="race.nameIta" [siLabel]="race.nameSlo"
                                                            [defaultLanguage]="event?.defaultLanguage"
                                                            [languages]="languages"/>

                              </ng-container>
                           </span>
                          </td>
                          }
                           @for (customColumn of customCols;track customColumn) {
                            <td class="center-align">
                              <span class="text-wrap">
                                {{ customColumn | competitorFieldValue: competitor }}
                              </span>
                            </td>
                          }
                          <td class="more-td text-end center-align"
                           [ngClass]="{'width-50': !currentCompetitor?.id,
                          'width-100': currentCompetitor?.id }">
                          @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                          === competitor?.id) {
                          <div class="d-flex justify-content-end">
                                <span class="menu-icon actions-button align-items-center pe-2" (click)="onSave()">
                                  <i class="bi bi-check-lg"></i>
                                </span>
                            <span class="menu-icon actions-button align-items-center" (click)="onCancel()">
                                  <i class="bi bi-x-lg"></i>
                                </span>
                          </div>
                          } @else {
                          <div ngbDropdown class="dropdown dropdown--remove-arrow" container="body">
                                <span class="menu-icon actions-button align-items-center" id="competitorActionsDropdown"
                                      ngbDropdownToggle>
                                  <i class="fas fa-ellipsis-v"></i>
                                </span>
                            <ul aria-labelledby="competitorActionsDropdown" ngbDropdownMenu>
                              <li ngbDropdownItem (click)="editCompetitor(competitor)">
                                {{ t("app.common.edit") }}
                              </li>
                              <li ngbDropdownItem (click)="goToDetails(competitor)">
                                {{ t("app.common.details") }}
                              </li>
                              <li ngbDropdownItem (click)="deleteCompetitor(competitor)">
                                {{ t("app.common.delete") }}
                              </li>
                            </ul>
                          </div>
                          }
                          </td>
                          </tr>
                          }
                        </tbody>
                      </app-sortable-table>
                    </div>
                  </div>
                </div>
              </div>
              @if (hasMore && showLoadMoreButton && !(gender || name || category)) {
                <app-admin-load-more (click)="loadMore()" />
              }
            </div>
          } @else if (showEmptyState) {
            <div class="px-3 px-lg-4 pt-2">
              <app-empty-state [isHorizontalMode]="true"/>
            </div>
          }
          @if (!this.showLoadMoreButton && showBorderBottom) {
            <div class="table-separator"></div>
          }
        </div>
      }
    </div>
  </ng-container>

  <ng-template #userTemplate>
    @if (showEmptyState || competitors.length > 0) {
      @if (showHeader) {
        <div>
          <app-races-header [race]="race" [showExportButton]="false" [showName]="true" [languages]="languages"
                            [defaultLanguage]="event?.defaultLanguage" [cssClass]="'small'" [isAdmin]="isAdmin">
          </app-races-header>
        </div>
      }
      <app-loader [isLoading]="isLoading"></app-loader>
      <div class="table-responsive competitor-table" [ngClass]="{'pt-16 mb-16': showHeader}">
        @if (filteringEnabled) {
          <div class="contestants-filter py-3 mb-3">
            <div class="d-flex flex-column flex-md-row">
              <div class="px-0 px-lg-4 px-md-0 me-md-3 pb-3 pb-md-0">
                <app-search [searchBarClass]="'extra-small'" [placeholder]="t('explore.search')"
                            (searchQuery)="handleSearchInput($event)" [inputValue]="name"/>
              </div>
              <form #f>
                <div class="contestants-filter__grid">
                  <div class="contestants-filter__grid-inner">
                    @if (isApplicationFormFieldVisible('sex')) {
                      <div ngbDropdown class="dropdown-small" container="body">
                        <div class="dropdown" id="genderDropdown" ngbDropdownToggle>
                          {{
                            gender ? t("app.common.gender." + gender) : t("competitor.table.gender")
                          }}
                        </div>
                        <div ngbDropdownMenu aria-labelledby="genderDropdown">
                          <button ngbDropdownItem (click)="handleGenderSelection()">
                            {{ t("app.common.all") }}
                            @if (!gender) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                          @for (item of genders;track item.id) {
                            <button ngbDropdownItem (click)="handleGenderSelection(item.id)">
                              {{ t("app.common.gender." + item.id) }}
                              @if (item.id === gender) {
                                <i class="bi bi-check"></i>
                              }
                            </button>
                          }
                        </div>
                      </div>
                    }
                    @if (isApplicationFormFieldVisible('category') && categories.length > 0) {
                      <div ngbDropdown class="dropdown-small" container="body">
                        <div class="dropdown" id="categoryDropdown" ngbDropdownToggle>
                          {{ category ?? t("competitor.table.category") }}
                        </div>
                        <div ngbDropdownMenu aria-labelledby="categoryDropdown">
                          <button ngbDropdownItem (click)="handleCategorySelection()">
                            {{ t("app.common.all") }}
                            @if (!category) {
                              <i class="bi bi-check"></i>
                            }
                          </button>
                          @for (categoryItem of categories;track categoryItem) {
                            <button ngbDropdownItem (click)="handleCategorySelection(categoryItem)">
                              {{ categoryItem.name }}
                              @if (categoryItem?.id === category) {
                                <i class="bi bi-check"></i>
                              }
                            </button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </form>
            </div>
          </div>
        }
        @if (competitors.length > 0) {
          <div>
            <div [ngClass]="{'scrollable-table': !showLoadMoreButton}"
                 (scroll)="!(gender || name || category) ? onScroll($event): undefined">
              @for (competitor of competitors;track competitor) {
                <ng-container>
                  <div class="align-items-center d-flex d-lg-none">
                    <div class="pe-4 fw-bolder fs-5">
                      @if (competitor.startNumber) {
                        {{ competitor.startNumber }}
                      } @else {
                        <span class="opacity-25">{{ '00' }}</span>
                      }
                    </div>
                    <div class="d-flex flex-column py-3 item-border-bottom flex-grow-1">
                      <div class="fw-bold line-height-12">
                        {{
                          ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName ?? "") | titlecase)
                        }}
                      </div>
                      <div class="d-inline-flex">-</div>
                      <div class="d-inline-flex">{{ t("app.common.gender." + competitor.sex) }}</div>
                      <ng-container>
                        <span class="fs-13-px fw-semibold">{{ ', ' }}{{ competitor.categoryLabel }}</span>
                      </ng-container>

                      <div class="d-flex flex-row">
                        <span class="badge rounded-pill ms-2">
                          {{ t("competitor.table.status." + competitor.status) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>
              }

              <div class="d-none d-lg-flex">
                <app-sortable-table [cssClass]="tableClasses"
                                    [items]="!currentCompetitor ? competitors: undefined">
                  <thead class="table-header">
                  <tr>
                    @for (field of competitorCols;track field) {
                      <th scope="col" [sortBy]="[field]">
                        <div class="d-flex align-items-end justify-content-start">
                          <div class="col-name-holder">
                            {{ t('competitor.table.' + field) }}
                          </div>
                          <div class="icon-holder">
                          </div>
                        </div>
                      </th>
                    }
                    @for (customColumn of customCols;track customColumn) {
                      <th scope="col">
                        <div class="d-flex align-items-end justify-content-start">
                          <div class="col-name-holder">
                            <app-language-output [hrLabel]="customColumn.name" [enLabel]="customColumn.nameEng"
                                                 [itLabel]="customColumn.nameIta" [siLabel]="customColumn.nameSlo"
                                                 [defaultLanguage]="event?.defaultLanguage"
                                                 [languages]="languages"/>
                          </div>
                          <div class="icon-holder">
                          </div>
                        </div>
                      </th>
                    }
                    <th scope="col" class="more-column-width text-end align-items-center justify-content-center">
                      <app-multiselect-dropdown [options]="getOptions()" [maxItemsCount]="maxColsNum"
                                                [disabled]="!!currentCompetitor" [ngModel]="selectedFields"
                                                (ngModelChange)="onSelectedFieldsChange($event)"
                                                buttonIconClass="bi bi-filter"
                                                [isTableHeading]="true" [isButton]="true"/>
                    </th>
                  </tr>
                  </thead>
                  <tbody #tbody>
                    @for (competitor of competitors;track competitor.id;let idx = $index) {
                      <tr class="fs-13-px fw-semibold clickable" (dblclick)="editCompetitor(competitor)">
                        @for (column of competitorCols;track column) {
                          <td class="center-align">
                            <span class="text-wrap">
                              @switch (column) {
                                @case ('startNumber') {
                                  @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                                  === competitor?.id) {
                                    <div class="d-flex">
                                      <ng-container>
                                        <input class="table-inp" placeholder="00"
                                               [(ngModel)]="currentCompetitor!.startNumber">
                                      </ng-container>
                                    </div>
                                  } @else {
                                    @if (competitor.startNumber) {
                                      {{ competitor.startNumber }}
                                    } @else {
                                      <span class="opacity-25">{{ '00' }}</span>
                                    }
                                  }
                                }
                                @case ('presentAtStart') {
                                  @if (currentCompetitor?.id && competitor?.id && currentCompetitor?.id
                                  === competitor?.id) {
                                    <div class="form-check form-switch d-flex align-items-center">
                                      <input ngDefaultControl class="form-check-input" type="checkbox"
                                             [(ngModel)]="currentCompetitor!.presentAtStart">
                                    </div>
                                  } @else {
                                    {{ competitor.presentAtStart ? t("app.common.yes") : t("app.common.no") }}
                                  }
                                }
                                @case ('status') {
                                  <div class="status-badge publishing" style="max-width: 100px">
                                    <span class="fw-bold">
                                      {{ t("competitor.table.status." + competitor.status) }}
                                    </span>
                                  </div>
                                }
                                @case ('sex') {
                                  {{ t("app.common.gender." + competitor.sex) }}
                                }
                                @case ('created') {
                                  {{ competitor.created ?? '' | localizedDate:'short' }}
                                }
                                @case ('modified') {
                                  {{ competitor.modified ?? '' | localizedDate:'short' }}
                                }
                                @case ('meal') {
                                  {{ t("app.common.meal." + competitor.meal) }}
                                }
                                @case ('transport') {
                                  {{ t("app.common.transport." + competitor.transport) }}
                                }
                                @case ('tshirt') {
                                  {{ t("app.common.tshirt." + competitor.tshirt) }}
                                }
                                @case ('fullName') {
                                  {{
                                    ((competitor?.firstName ?? "")| titlecase) + " " + ((competitor?.lastName
                                      ?? "") | titlecase)
                                  }}
                                }
                                @default {
                                  {{ competitor[column] ?? "-" }}
                                }
                              }
                            </span>
                          </td>
                        }
                        @for (customColumn of customCols;track customColumn) {
                          <td class="center-align">
                            <span class="text-wrap">
                              {{ customColumn | competitorFieldValue: competitor }}
                            </span>
                          </td>
                        }
                        <td class="text-end align-items-end justify-content-center"></td>
                      </tr>
                    }
                  </tbody>
                </app-sortable-table>
              </div>
            </div>
            @if (hasMore && showLoadMoreButton && !(gender || name || category)) {
              <div class="d-flex justify-content-center load-more-wrapper pt-2 pb-2">
                <app-rounded-button [label]="t('app.common.load.more')" (onClick)="loadMore()"/>
              </div>
            }
          </div>
        } @else if (showEmptyState) {
          <div class="px-3 px-lg-4 pt-2">
            <app-empty-state [isHorizontalMode]="true"/>
          </div>
        }
        @if (!this.showLoadMoreButton && showBorderBottom) {
          <div class="table-separator"></div>
        }
      </div>
    }
  </ng-template>
</ng-container>
